import { useEffect } from "react";
import { Navigate, useNavigate, useLocation, useSearchParams } from "react-router-dom";
import { useAuth } from "../contexts/auth";
import {
  isActionAuthorized,
  isTokenExpired,
  isTokenPresent,
} from "../utils/auth";
import { USER_TYPE } from "../utils/constants";
import { getToken, login } from "../utils/auth";

const ProtectedRoute = ({ roles, children }) => {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // check if a token is present and is valid
    if (!isTokenExpired()) {
      if (!user.roles.includes(USER_TYPE.AUTHENTICATED)) {
        setUser((pUser) => {
          return {
            ...pUser,
            roles: [...pUser.roles, USER_TYPE.AUTHENTICATED],
          };
        });
      }
      navigate({ pathname: pathname, search: `?${searchParams}` });
    } else {
      // get a new token, permanently store it, set state in app
      (async () => {
        let token = await getToken();
        login(token);
        if (!user.roles.includes(USER_TYPE.AUTHENTICATED)) {
          setUser((pUser) => ({
            ...pUser,
            roles: [...pUser.roles, USER_TYPE.AUTHENTICATED],
          }));
        }
      navigate({ pathname: pathname, search: `?${searchParams}` });
      })();
    }
  }, [user, setUser, navigate, pathname, searchParams]);

  return isActionAuthorized(roles, user.roles) ? (
    children
  ) : isTokenPresent() ? (
    <Navigate to="/unauthorized" />
  ) : null;
};

export default ProtectedRoute;
